import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_voyage-suite-1/artifacts/q7oh88qy_Blue%20and%20Red%20Travel%20Tours%20Agency%20Logo.jpg";

/**
 * Brand logo. The uploaded artwork lives on a white canvas, so on our dark
 * theme we present it inside a small white "stamp" card for brand integrity.
 * On light surfaces (hero/cover), use variant="light".
 */
export function Logo({ size = "default", variant = "dark", showText = true, className = "" }) {
  const map = {
    small: { box: "h-9 w-9 p-1", head: "text-sm", sub: "text-[9px]" },
    default: { box: "h-11 w-11 p-1", head: "text-base", sub: "text-[10px]" },
    large: { box: "h-14 w-14 p-1.5", head: "text-xl", sub: "text-xs" },
    xl: { box: "h-28 w-28 p-2", head: "text-3xl", sub: "text-sm" },
  };
  const s = map[size] || map.default;

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <div className={`${s.box} rounded-md bg-white flex items-center justify-center shadow-[0_4px_20px_-8px_rgba(212,175,55,0.25)] ring-1 ring-[#D4AF37]/30`}>
        <img
          src={LOGO_URL}
          alt="Best Time Travel & Tours"
          className="w-full h-full object-contain select-none"
          draggable={false}
        />
      </div>
      {showText && (
        <div className="hidden sm:flex flex-col leading-tight">
          <span className={`font-serif ${s.head} tracking-tight ${variant === "light" ? "text-ink" : "text-white"}`}>
            Best <span className="text-[#D4AF37] italic">Time</span>
          </span>
          <span className={`${s.sub} uppercase tracking-[0.3em] ${variant === "light" ? "text-ink/60" : "text-white/50"} font-sans`}>
            Travel &amp; Tours
          </span>
        </div>
      )}
    </div>
  );
}
